'use client';

import { atom } from 'jotai';

export const isEmptyPayloadAtom = atom(false);
